<template>
  <div class="eds-comp-search">
    <div class="search-input remove-min-height">
      <v-text-field v-model="searchInfo" solo flat clearable color="rgb(48, 133, 214)" :label="$t('请输入')"
        prepend-inner-icon="search" @click:prepend-inner="onSearch" @input="onSearch"></v-text-field>
    </div>
  </div>
</template>

<script>
import msgbus from '../msgBus'

export default {
  name: 'eDS-CompSearch',
  props: {
    initSearchInfo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchInfo: '',
    }
  },
  computed: {},
  methods: {
    // 搜索
    onSearch() {
      // 读取过滤配置
      this.$emit('onSaveSearchSet', this.searchInfo)
    },
  },
  created() {
    console.log('调试代码')
    this.searchInfo = this.initSearchInfo
  },
  mounted() { },
}
</script>


<style lang="scss">
.eds-comp-search {
  width: 100%;
  padding: 0.5rem 0rem;
  background-color: #fff;
  height: 50px;

  .search-input {
    width: 100%;
    display: inline-block;
    vertical-align: middle;

    &.remove-min-height {
      min-height: 0;
      padding: 0rem 2rem 0rem 2rem;

      .v-input__control {
        min-height: 0px;

        .v-input__slot {
          border: 1px solid rgb(48, 133, 214);
          margin-bottom: 0;

          input {
            font-size: 1rem;
          }
        }

        .v-text-field__details {
          display: none;
        }
      }

      .v-input__slot {
        border-radius: 9999px;
      }

      .theme--light.v-icon {
        color: rgb(48, 133, 214);
      }

      .v-text-field.v-text-field--solo .v-label {
        opacity: 0.7;
        font-size: 1rem;
        color: #8a8a8a;
      }
    }
  }
}
</style>